import PropTypes from 'prop-types'
import { Range } from 'react-range'

export default function DurationSlider({
  min,
  max,
  step,
  value,
  onChange,
  availableSteps = []
}) {
  const handleChange = (values) => {
    const newValue = values[0]
    if (availableSteps.length > 0) {
      const closest = availableSteps.reduce((prev, curr) =>
        Math.abs(curr - newValue) < Math.abs(prev - newValue) ? curr : prev
      )
      onChange(closest)
    } else {
      onChange(newValue)
    }
  }

  return (
    <Range
      step={step}
      min={min}
      max={max}
      values={[value]}
      onChange={handleChange}
      renderTrack={({ props, children }) => (
        <div {...props} className='relative h-1 w-full rounded bg-gray-200'>
          <div
            className='absolute h-1 rounded bg-brightBlue'
            style={{
              left: 0,
              width: `${((value - min) / (max - min)) * 100}%`,
              top: 0,
              bottom: 0
            }}
          />
          {children}
        </div>
      )}
      renderThumb={({ props, isDragged }) => (
        <div
          {...props}
          className={`flex h-6 w-4 items-center justify-center rounded-2xl border-2 border-brightBlue bg-white ${
            isDragged ? 'ring-2 ring-brightBlue' : ''
          }`}
        />
      )}
    />
  )
}

DurationSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  availableSteps: PropTypes.arrayOf(PropTypes.number)
}
